import { Company } from '../models/Company';
import { Roles } from '../models/Roles';
import { User } from '../models/User';
import { userApiProvider } from './providers/userApiProvider';
var users = {
    getAll: function getAll() {
        return userApiProvider.get("/users", User);
    },
    getById: function getById(userId) {
        return userApiProvider.get("/users/".concat(userId), User);
    },
    update: function update(user) {
        return userApiProvider.post("/users/".concat(user.id), user, User);
    }
};
var companies = {
    getAll: function getAll() {
        return userApiProvider.get("/companies", Company);
    }
};
var roles = {
    getAll: function getAll() {
        return userApiProvider.get("/roles", Roles);
    },
    getRole: function getRole(roleId) {
        return userApiProvider.get("/roles/".concat(roleId), Roles);
    },
    create: function create(role) {
        return userApiProvider.put("/roles", role, Roles);
    },
    update: function update(roleId, role) {
        return userApiProvider.post("/roles/".concat(roleId), role, Roles);
    },
    delete: function _delete(roleId) {
        return userApiProvider.del("/roles/".concat(roleId));
    }
};
var userDetails = {
    getByUserName: function getByUserName(username) {
        return userApiProvider.post("/user-details/dto", {
            username: username
        });
    }
};
var internalPrincipal = {
    getCurrent: function getCurrent() {
        return userApiProvider.get("/internal-principal/current");
    }
};
var userApi = {
    users: users,
    companies: companies,
    roles: roles,
    userDetails: userDetails,
    internalPrincipal: internalPrincipal
};
export default userApi;
